var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2476_44606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4367 30.1102C13.0472 31.6698 14.9963 32.8383 16.1648 31.5384L23.8329 23.2196L31.3711 22.8317C32.9307 22.7018 34.0992 21.5302 34.0992 19.9706C34.0992 18.411 32.9291 17.2425 31.3711 17.1111L23.8329 16.7216L16.1648 8.40433C14.9947 7.23425 13.0456 8.2745 13.4367 9.8325L15.2559 16.9813C14.0716 17.0272 12.0877 17.5418 10.9683 16.9813L7.84752 15.4233C7.4596 15.1636 6.9371 15.2934 6.5476 15.4233C6.15969 15.6829 5.89844 16.074 5.89844 16.5933C5.89844 17.4594 6.51435 18.2273 6.93869 18.9335C7.3266 19.5827 7.3266 20.3617 6.93869 21.0124C6.4811 21.774 5.89844 22.439 5.89844 23.351C5.89844 23.8719 6.1581 24.2614 6.5476 24.5211C6.74053 24.6482 6.96651 24.716 7.19756 24.716C7.42862 24.716 7.65459 24.6482 7.84752 24.5211L10.9667 22.9615C12.0956 22.3978 14.032 22.914 15.2544 22.9615L13.4367 30.1102Z",
    stroke: "#212529",
    strokeWidth: 2.08333,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2476_44606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6667,
    height: 31.6667,
    fill: "white",
    transform: "translate(4.16406 4.16797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.24b1eb5a960f01aece97443cba7a24fd.svg";
export { ForwardRef as ReactComponent };